import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  title: string;
  live?: boolean;
  className?: string;
  /** Optional right-aligned meta (e.g. a muted count/context) — uses the row width for real
   *  information instead of a filler rule. */
  children?: React.ReactNode;
  /** @deprecated The Quiet header carries no eyebrow. Accepted so legacy callers still type-check, but
   *  it is intentionally not rendered. Remove the prop from callers as each page is reworked. */
  eyebrow?: string;
}

/** The one subsection header used across the product — the "Quiet" style: a single-line title with no
 *  divider rule and no eyebrow. Separation comes from the surrounding whitespace, not chrome. An
 *  optional muted meta node sits on the right. Applied identically on every page so section headers
 *  never drift between surfaces. */
export function SectionHeader({ title, live, className, children }: SectionHeaderProps) {
  return (
    <div className={cn("flex items-baseline justify-between gap-4", className)}>
      <h2 className="flex items-center gap-2 text-lg font-semibold leading-tight tracking-tight">
        {title}
        {live ? (
          <span
            aria-label="live"
            className="inline-block size-2 rounded-full bg-[var(--color-success)] animate-pulse-soft"
          />
        ) : null}
      </h2>
      {children ? (
        <div className="flex shrink-0 items-center gap-2 text-sm text-muted-foreground">{children}</div>
      ) : null}
    </div>
  );
}
